<h2 mat-dialog-title>
  Coins Section Screenshot
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <div class="screenshot-container">
    <img [src]="data.imageUrl" alt="Screenshot of coins section" />
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
  <button mat-raised-button color="primary" (click)="copyToClipboard()">
    <mat-icon>content_copy</mat-icon>
    Copy to Clipboard
  </button>
</mat-dialog-actions>
